// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__19fdO","title":"Header_title__hQ7BS","left":"Header_left__3l8zg","clinicName":"Header_clinicName__34hIf"};